<template>
    <v-app app>
        <v-main>
            <HeadView :loading="loading" :loadingchair="loadingchair"></HeadView>
            <v-card class="mx-auto" max-width="448" v-if="$route.name!='LOGIN'">
                <v-app-bar color="red-darken-1" density="compact">
                    <v-app-bar-title v-if="$store.state.empresaweb!=undefined">{{ $store.state.empresaweb + ' ' + $store.state.theater_name }}</v-app-bar-title>
                    <template v-slot:prepend>
                        <v-btn value="home" @click="$router.push('/');" :disabled="$route.name === 'HOME'">
                            <v-table density="compact">
                                <tr><td class="bg-red-darken-1"><v-icon size="large">mdi-movie-roll</v-icon></td></tr>
                                <tr><td class="bg-red-darken-1 text-capitalize"><span>Películas</span></td></tr>
                            </v-table>
                        </v-btn>
                        <v-btn value="dulceria" :disabled="$route.name==='SWEETSHOP'"
                            @click="$router.push({
                                name: 'SWEETSHOP',
                                params: { obj: JSON.stringify({'codpro': null})}
                            });"
                        >
                            <v-table>
                                <tr><td class="bg-red-darken-1"><v-icon size="large">mdi-popcorn</v-icon></td></tr>
                                <tr><td class="bg-red-darken-1 text-capitalize"><span>Dulcería</span></td></tr>
                            </v-table>
                        </v-btn>
                        <ShowCartView :is_sweet_shop="is_sweet_shop"></ShowCartView>
                    </template>
                    <template v-slot:append>
                        <v-btn value="anular_compra" @click="cancel()">
                            <v-table density="compact">
                                <tr><td class="bg-red-darken-1"><v-icon size="large">mdi-delete-forever</v-icon></td></tr>
                                <tr><td class="bg-red-darken-1 text-capitalize"><span>Anular Compra</span></td></tr>
                            </v-table>
                        </v-btn>
                        <v-btn value="acerca_de" @click="about($store.state.kiosk_name)">
                            <v-table density="compact">
                                <tr><td class="bg-red-darken-1"><v-icon size="large">mdi-help-circle</v-icon></td></tr>
                                <tr><td class="bg-red-darken-1 text-capitalize"><span>Ayuda</span></td></tr>
                            </v-table>
                        </v-btn>     
                        <v-divider class="border-opacity-0" color="info" :thickness="2" vertical></v-divider>
                        <v-progress-circular @click="viewmaxtimekiosk()"
                            color="yellow-accent-2"
                            bg-color="grey-darken-1"
                            :size="30"
                            :width="5"
                            :model-value="$store.state.globalTimeoutCompletePurchase"
                            :class="`cursor-pointer`"
                        ></v-progress-circular>
                    </template>
                </v-app-bar>
            </v-card>
            <router-view></router-view>
      </v-main>
    </v-app>
</template>

<script>
  import Swal from 'sweetalert2';
  import API from './api';
  import HeadView from './components/HeadView.vue';
  import ShowCartView from './components/ShowCartView.vue';
  
  export default {
    name: 'App',
    components: {
      HeadView,
      ShowCartView
    },
    data() {
      return {
        token_cineland: null,
        usrlock: null,
        theater_id: null,
        kiosk_id: null,
        is_sweet_shop: false,
        loading: false,
        loadingchair: false,
        dialog_cart: false,
      }
    },
    mounted() {
      setInterval(() => {
        try {
            if (this.$store.state.globalMaxTimeKiosk == 0) {
                this.$store.state.globalMaxTimeKiosk = 10;
            }
            if (this.$store.state.globalTimeOut+1 < this.$store.state.globalMaxTimeKiosk) {
                if (this.$store.state.carts_count > 0) {
                    this.$store.state.globalTimeOut = this.$store.state.globalTimeOut+1;
                    this.$store.state.globalTimeoutCompletePurchase = this.$store.state.globalTimeOut * (100/this.$store.state.globalMaxTimeKiosk);
                } else {
                    this.$store.state.globalTimeOut = 0;
                    this.$store.state.globalTimeoutCompletePurchase = 0;
                }
            } else {
                this.$store.state.globalTimeOut = this.$store.state.globalMaxTimeKiosk;
                this.$store.state.globalTimeoutCompletePurchase = 100;
                this.$store.state.dialog_cart = false;
                this.token_cineland = localStorage.getItem('token_cineland');
                this.usrlock = localStorage.getItem('usrlock');
                if (this.token_cineland!=undefined && this.token_cineland!=null && this.usrlock!=undefined && this.usrlock!=null && this.usrlock!='' && this.$store.state.carts_count > 0) {                    
                    Swal.fire({
                        title: 'Atención',
                        html: 'El tiempo para completar la compra ha finalizado',
                        icon: 'info',
                        confirmButtonText: 'Aceptar',
                        timer: 3000,
                        timerProgressBar: true,
                        customClass: {
                        timerProgressBar: 'my-timer-progress_bar-class'
                        },
                    });
                    this.loading = true;                
                    let formdata = new FormData();
                    formdata.append('usrlock', this.usrlock);
                    API.post('api_point_back.php', formdata, { headers: {
                        'Authorization': this.token_cineland,
                        'Route': 'set_delete_shop'
                    }}).then(response => {                            
                        if (response.data.transaction_status && response.data.transaction_status.code == 200) {                        
                            console.log('Compra Anulada Exitosamente SetInterval');
                        } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
                        } else {
                            this.loading = false;
                            Swal.fire({
                                title: 'Error',
                                html: response.data.transaction_status.msg,
                                icon: 'error',
                                confirmButtonText: 'Aceptar',
                            });
                        }
                    }).catch(error => {
                        this.loading = false;
                        Swal.fire({
                            title: 'Error',
                            html: 'Se ha presentado un error, intenta nuevamente',
                            icon: 'error',
                            confirmButtonText: 'Aceptar',
                        });
                        console.log('error front ' + error);
                    }).finally(() => this.loading = false);
                }
                this.loading = false;
                localStorage.removeItem('usrlock');
                localStorage.removeItem('codigotc');            
                localStorage.removeItem('tab_date');
                localStorage.removeItem('question_cineland_card');
                localStorage.removeItem('membership_type');
                localStorage.removeItem('document_premium_membership');
                this.$store.state.carts_count = 0;
                this.$store.state.view_cart = false;
                this.$store.state.globalTimeOut = 0;
                this.$store.state.globalTimeoutCompletePurchase = 0;
                this.$router.push("/");
            }
        } catch (error) {
            console.log(error);
        }
      }, 1000*60);
    },
    methods: {
        cancel() {        
            this.usrlock = localStorage.getItem('usrlock');
            this.token_cineland = localStorage.getItem('token_cineland');
            if (this.token_cineland!=undefined && this.token_cineland!=null && this.usrlock!=undefined && this.usrlock!=null) {
                Swal.fire({
                    title: 'ATENCION',
                    html: 'Desea Anular esta Compra',
                    icon: 'info',
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.loading = true;
                        localStorage.removeItem('question_cineland_card');
                        let formdata = new FormData();
                        formdata.append('usrlock', this.usrlock);
                        API.post('api_point_back.php', formdata, { headers: {
                            'Authorization': this.token_cineland,
                            'Route': 'set_delete_shop'
                        }}).then(response => {                            
                            if (response.data.transaction_status && response.data.transaction_status.code == 200) {
                                console.log('Compra Anulada Exitosamente');
                                /*localStorage.removeItem('codigotc');
                                localStorage.removeItem('membership_type');
                                localStorage.removeItem('document_premium_membership');
                                localStorage.removeItem('usrlock');
                                localStorage.removeItem('tab_date');
                                localStorage.removeItem('question_cineland_card');*/
                            } else if (response.data.transaction_status && process.env.VUE_APP_API_INVALID_TOKEN.includes(response.data.transaction_status.code)) {
                                this.loading = false;
                                this.$router.push("/");
                            } else {
                                this.loading = false;
                                Swal.fire({
                                    title: 'Error',
                                    html: response.data.transaction_status.msg,
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar',
                                });
                            }
                        }).catch(error => {
                            this.loading = false;
                            Swal.fire({
                                title: 'Error',
                                html: 'Se ha presentado un error, intenta nuevamente',
                                icon: 'error',
                                confirmButtonText: 'Aceptar',
                            });
                            console.log('error front ' + error);
                        }).finally(() => this.loading = false);
                        this.$store.state.carts_count = 0;
                        this.$store.state.view_cart = false;
                        localStorage.removeItem('membership_type');
                        localStorage.removeItem('document_premium_membership');
                        localStorage.removeItem('codigotc');
                        localStorage.removeItem('usrlock');
                        localStorage.removeItem('tab_date');
                        localStorage.removeItem('question_cineland_card');
                        Swal.fire({
                            title: 'Atención',
                            html: 'Compra anulada exitosamente',
                            icon: 'success',
                            confirmButtonText: 'Aceptar',
                            timer: 2000,
                            timerProgressBar: true,
                            customClass: {
                                timerProgressBar: 'my-timer-progress_bar-class'
                            },
                        });
                        this.$router.push('/');
                    }
                })
            } else {
                console.log('Usrlock in blank');
            }
        },
        
        about(name_view) {
            Swal.fire({
                title: 'Información del Kiosko',
                html: name_view,
                icon: 'info',
                confirmButtonText: 'Aceptar',
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    timerProgressBar: 'my-timer-progress_bar-class'
                },
            });
        },
        
        viewmaxtimekiosk() {        
            Swal.fire({
                title: 'Tiempo para finalizar Compra',
                html: 'Máximo '+this.$store.state.globalMaxTimeKiosk.toString()+' Minutos',
                icon: 'info',
                confirmButtonText: 'Aceptar',
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    timerProgressBar: 'my-timer-progress_bar-class'
                },
            });
        },
                
    }
  }
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

  .swal2-confirm{
    background-color: green !important;
    color: #FFFFFF !important;
  }
  
  .swal2-cancel{
    background-color: red !important;
    color: #FFFFFF !important;
  }

  .swal2-container {
    z-index: 20000 !important;
  }
  
  .my-timer-progress_bar-class {
    background-color: magenta !important; 
    color:  magenta !important;
    height: 1rem
  }  
</style>